/**
 * Email/password auth: store and read JWT in sessionStorage.
 * Backend issues JWT on POST /v1/auth/login; we send it as Bearer for /v1/users/me etc.
 * Dispatches a custom event so useAuth and other consumers can react to token set/clear.
 */

import { EMAIL_TOKEN_KEY } from '@/auth/config';

const EMAIL_AUTH_CHANGE_EVENT = 'silisense-email-auth-change';

export function getStoredEmailToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return sessionStorage.getItem(EMAIL_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setStoredEmailToken(token: string): void {
  try {
    sessionStorage.setItem(EMAIL_TOKEN_KEY, token);
    window.dispatchEvent(new CustomEvent(EMAIL_AUTH_CHANGE_EVENT));
  } catch (e) {
    console.warn('Could not store email token', e);
  }
}

export function clearStoredEmailToken(): void {
  try {
    sessionStorage.removeItem(EMAIL_TOKEN_KEY);
    window.dispatchEvent(new CustomEvent(EMAIL_AUTH_CHANGE_EVENT));
  } catch {
    // ignore
  }
}

/** Subscribe to email token set/clear (for useAuth). */
export function subscribeEmailAuthChange(callback: () => void): () => void {
  window.addEventListener(EMAIL_AUTH_CHANGE_EVENT, callback);
  return () => window.removeEventListener(EMAIL_AUTH_CHANGE_EVENT, callback);
}
